module.exports = __webpack_public_path__ + "img/imediata.beb8c0df.svg";